import axios from 'axios';

import { WP_URL } from '../components/Common/const';

export function getResourcesPosts(page, limit, order = 'desc', category = []) {
  if (category.length === 0) {
    return axios
      .get(
        `${WP_URL}posts/?_embed&page=${page}&per_page=${limit}&order=${order}`,
      )
      .then(({ data, headers }) => ({
        data,
        totalPages: headers['x-wp-totalpages'],
      }));
  }
  return axios
    .get(
      `${WP_URL}posts/?_embed&page=${page}&per_page=${limit}&order=${order}&categories=${category}`,
    )
    .then(({ data, headers }) => ({
      data,
      totalPages: headers['x-wp-totalpages'],
    }));
}

export function getPostCategories() {
  return axios.get(`${WP_URL}categories`).then(({ data }) => data);
}

export function getFeaturedBlog() {
  return axios
    .get(`${WP_URL}posts/?_embed&page=1&per_page=1&order=desc`)
    .then(({ data }) => data);
}
